import { lazy } from "react";

export const LandingComponent = lazy(() =>
	import("../organisms/Landing")
);
